import React, {Fragment} from "react";
import CustomList_Delete from "./CustomList_Delete";
import CustomListField from "./CustomListField";

const CustomList_3cells = ({rowKey, config, last=false}) => {

    const columnName = index => `${config.namePrefix}${config.columns[index].namePrefix}${rowKey}`;
    const columnLabel = index => config.columns[index].label;
    const columnPlaceholder = index => config.columns[index].placeholder ?? config.placeholder;
    const columnRequired = index => config.columns[index].required ?? true;

    const renderField = index => <CustomListField name={columnName(index)} placeholder={columnPlaceholder(index)} />
    const renderLabel = index => <label htmlFor={columnName(index)} className="m-lg-0">{columnLabel(index)}{columnRequired(index) && <sup>*</sup>}</label>

    return (
        <Fragment key={rowKey}>
            <div className={`col-12 col-lg-${config.rowTemplate_cols[0]}`}>
                {renderLabel(0)}
            </div>
            <div className={`col-12 col-lg-${config.rowTemplate_cols[1]} ${last?'':'custom-list-block'}`}>
                <div className="row no-gutters">
                    <div className={`col-12 col-lg-${config.rowTemplate_cols[2]}`}>
                        {renderField(0)}
                    </div>
                    <div className={`col-12 col-lg-${config.rowTemplate_cols[3]} border-left`}>
                        <div className="row no-gutters">
                            <div className={`col-12 col-lg-${config.rowTemplate_cols[4]}`}>
                                {renderLabel(1)}
                            </div>
                            <div className={`col-12 col-lg-${config.rowTemplate_cols[5]}`}>
                                {renderField(1)}
                            </div>
                            <div className={`col-1 col-lg-${config.rowTemplate_cols[6]} text-center`}>
                                <CustomList_Delete config={config} rowKey={rowKey} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default CustomList_3cells;